import { render } from "./LandingPolz.vue?vue&type=template&id=5141168e"
import script from "./LandingPolz.vue?vue&type=script&lang=js"
export * from "./LandingPolz.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__